"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScenarioManager = void 0;
var ImageObject_1 = require("../resource/ImageObject");
var logger_1 = require("../utils/logger");
var ScenarioManager = /** @class */ (function () {
    function ScenarioManager() {
        this.background = new ImageObject_1.ImageObject();
        this.backlist = [];
        this.saveDataList = [];
        this.progress = {
            currentBackground: '',
            currentScene: '',
            currentIndex: 0,
            selected: {
            // '{scene名}'：[id]
            }
        };
    }
    ScenarioManager.prototype.setScenario = function (scenario, sceneName) {
        if (sceneName === void 0) { sceneName = ''; }
        (0, logger_1.outputLog)('call', 'debug', { scenario: scenario, sceneName: sceneName });
        this.scenarioData = scenario;
        this.progress.currentScene = sceneName;
        this.progress.currentIndex = 0;
    };
    ScenarioManager.prototype.addScenario = function (scenario, index) {
        var _a, _b;
        // 区別にsub=trueを追加
        var _scenario = scenario.map(function (item) { return (__assign(__assign({}, item), { sub: true })); });
        (0, logger_1.outputLog)('call', 'debug', { scenario: scenario, index: index });
        // index指定がある場合はその値に挿入する
        if (index) {
            (_a = this.scenarioData).splice.apply(_a, __spreadArray([index, 0], _scenario, false));
        }
        else {
            // 現在の位置に挿入する
            (_b = this.scenarioData).splice.apply(_b, __spreadArray([this.progress.currentIndex, 0], _scenario, false));
        }
        (0, logger_1.outputLog)('call', 'debug', this.scenarioData);
    };
    ScenarioManager.prototype.getScenario = function () {
        return this.scenarioData;
    };
    ScenarioManager.prototype.next = function () {
        (0, logger_1.outputLog)('call: index:', 'debug', this.progress.currentIndex);
        if (this.progress.currentIndex <= this.scenarioData.length) {
            var nextScenario = this.scenarioData[this.progress.currentIndex];
            this.progress.currentIndex += 1;
            return nextScenario;
        }
        else {
            return null;
        }
    };
    ScenarioManager.prototype.hasNext = function () {
        return this.progress.currentIndex < this.scenarioData.length;
    };
    ScenarioManager.prototype.getIndex = function () {
        return this.progress.currentIndex;
    };
    ScenarioManager.prototype.setIndex = function (index) {
        (0, logger_1.outputLog)('call index:', 'debug', index);
        this.progress.currentIndex = index;
    };
    ScenarioManager.prototype.setSceneName = function (sceneName) {
        this.progress.currentScene = sceneName;
    };
    ScenarioManager.prototype.getSceneName = function () {
        return this.progress.currentScene;
    };
    ScenarioManager.prototype.setHistory = function (text) {
        this.backlist.push(text);
    };
    ScenarioManager.prototype.setSelectedChoice = function (prompt, id) {
        this.progress.selected[this.progress.currentScene] = { prompt: prompt, id: id };
    };
    ScenarioManager.prototype.setBackground = function (image) {
        this.background = image;
    };
    ScenarioManager.prototype.getBackground = function () {
        return this.background;
    };
    return ScenarioManager;
}());
exports.ScenarioManager = ScenarioManager;
//# sourceMappingURL=scenarioManager.js.map